// extracted by mini-css-extract-plugin
export default {"recommended":"styles_recommended__czG-K","userNavigationMenu":"styles_userNavigationMenu__rFVLl","column":"styles_column__euIme","icon":"styles_icon__NOdFL"};